export default __webpack_public_path__ + "static/media/logo.faf693c4.png";